export default "/Frontend/dist/csv.e1364b12948e4d415853f820c9c4a13e.svg";